<mat-dialog-content class="mat-typography">
    <div class="example-form" *ngIf="data">
        <mat-tab-group  [backgroundColor]="'primary'" [color]="'accent'">
            <mat-tab label="Main"><app-main-details [(data)]="data"></app-main-details></mat-tab>
            <mat-tab label="GDPR"><app-gdpr-details [(data)]="data"></app-gdpr-details></mat-tab>
            <mat-tab label="Terms"><app-terms-details [(data)]="data"></app-terms-details></mat-tab>
          </mat-tab-group>
    </div>
 </mat-dialog-content>
 <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true"><mat-icon>cancel</mat-icon>Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="false" cdkFocusInitial (click)="save()"><mat-icon>save</mat-icon>Save</button>
  </mat-dialog-actions>
